jQuery(document).ready(function ($) {
    const $searchForm = $('.search-form');

  // observe changes to class attribute of live-search wrapper
  // if the results are showing add a utility class to the search-form
    const observer = new MutationObserver((mutationsList, _) => {
        for (const mutation of mutationsList) {
            if (mutation.attributeName === 'class') {
                if (mutation.target.classList.contains('searchwp-live-search-results-showing') &&
                !mutation.target.classList.contains('searchwp-live-search-no-min-chars')) {
                    $searchForm.addClass('search-form--results-showing');
                } else {
                    $searchForm.removeClass('search-form--results-showing');
                }
            }
        }
    });

  // wait for the live-search wrapper to be present before observing
    const observerInterval = setInterval(() => {
        const searchWpLiveSearchResults = document.querySelector('.searchwp-live-search-results');
        if (searchWpLiveSearchResults !== null) {
            clearInterval(observerInterval);
            observer.observe(searchWpLiveSearchResults, {
                attributes: true,
            });
        }
    }, 100);
});
